import {
  FETCH_PLANNING_FAILURE,
  FETCH_PLANNING_REQUEST,
  FETCH_PLANNING_SUCCESS,
} from "../actions/planning.actions";

const initialState = {
  data: [],
  loading: false,
};

const planning = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PLANNING_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_PLANNING_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
      };
    case FETCH_PLANNING_FAILURE:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
};

export default planning;
